import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ubi-layout-detail',
  templateUrl: './ubiLayoutDetail.component.html',
  styleUrls: ['./ubiLayoutDetail.component.scss']
})
export class UbiLayoutDetailComponent implements OnInit {

  @Input() status: any;

  @Output()
  save = new EventEmitter();

  @Output()
  delete = new EventEmitter();

  @Output()
  cancel = new EventEmitter();

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
  }

  public saveClick(event) {
    this.save.emit(true);
  }

  public deleteClick(event, content) {

    this.modalService.open(content, { backdrop: 'static', keyboard: false }).result.then((result) => {
      if (result === 'Delete') {
        this.delete.emit(true);
      }
    });

  }

  public cancelClick(event) {
    this.cancel.emit(true);
  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiLayoutDetail/ubiLayoutDetail.component.ts